import axiosInstance from '../../../../services/api';

const BULK_INITIALIZE_API_ENDPOINT = '/api/active-substances/bulk-initialize/';

/**
 * Normalize an array of IDs - ensures each ID is separate (splits comma-separated strings)
 * @param {Array} arr - Array that may contain comma-separated strings
 * @returns {Array<string>} - Array of individual IDs
 */
const normalizeIdArray = (arr) => {
  if (!arr || !Array.isArray(arr)) return [];

  return arr.flatMap((item) => {
    if (typeof item === 'string' && item.includes(',')) {
      return item.split(',').map((id) => id.trim()).filter(Boolean);
    }
    return item;
  }).filter(Boolean);
};

/**
 * Service for active substance bulk initialization API
 * Fetches labels for IDs when restoring URL state (cold start)
 */
export const ActiveSubstanceBulkInitializeService = {
  /**
   * Bulk fetch labels for active substance URL state restoration
   * @param {Object} ids - Object containing arrays of IDs to fetch
   * @returns {Promise<Object>} Labels for all provided IDs
   */
  async bulkInitialize(ids) {
    try {
      const { data } = await axiosInstance.post(BULK_INITIALIZE_API_ENDPOINT, {
        culture_ids: normalizeIdArray(ids.culture_ids),
        activity_sector_ids: normalizeIdArray(ids.activity_sector_ids),
        cultural_practice_ids: normalizeIdArray(ids.cultural_practice_ids),
        chemical_family_ids: normalizeIdArray(ids.chemical_family_ids),
        pesticide_group_ids: normalizeIdArray(ids.pesticide_group_ids),
        pesticide_category_ids: normalizeIdArray(ids.pesticide_category_ids),
        pesticide_type_ids: normalizeIdArray(ids.pesticide_type_ids),
        activity_type_ids: normalizeIdArray(ids.activity_type_ids),
        arla_culture_group_ids: normalizeIdArray(ids.arla_culture_group_ids),
        resistance_ids: normalizeIdArray(ids.resistance_ids),
      });
      return data;
    } catch (error) {
      console.error('[ActiveSubstanceBulkInitialize] API error:', error);
      throw error;
    }
  },
};

export default ActiveSubstanceBulkInitializeService;
